import { gate } from 'hub-http/gates';
import { useIsUngatedForIARedesign } from './useIsUngatedForIARedesign';
export const useIsUngatedForVizSettingsM1 = () => {
  const isUngatedForVizSettingsM1 = useIsUngatedForIARedesign(gate('CRM:Datasets:VizSettingsM1'));
  return Boolean(isUngatedForVizSettingsM1);
};